import { Globe, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLocale } from "@wovendays/i18n";
import type { Locale } from "@wovendays/i18n";

interface LanguagePickerProps {
  onLocaleChange?: (locale: Locale) => void;
}

export function LanguagePicker({ onLocaleChange }: LanguagePickerProps) {
  const { locale, setLocale, supportedLocales, localeLabels } = useLocale();

  const handleSelect = (newLocale: Locale) => {
    setLocale(newLocale);
    onLocaleChange?.(newLocale);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Change language">
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {supportedLocales.map((loc) => (
          <DropdownMenuItem key={loc} onClick={() => handleSelect(loc)}>
            {locale === loc && <Check className="mr-2 h-4 w-4" />}
            {locale !== loc && <span className="mr-2 w-4 inline-block" />}
            {localeLabels[loc]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
